class PricingCalculator {
    constructor() {
        this.stairType = null; // Track the current stair type
        this.pricingModule = null; // Reference to the pricing module for the current stair type
    }

    // Function to set the current stair type and load the corresponding pricing module
    async setStairType(stairType, stairInstance, isCantilever) {
        console.log(`Setting stair type to ${stairType}, Cantilever: ${isCantilever}`);
        this.stairType = stairType;
        
        try {
            const startTime = Date.now();
            if (isCantilever) {
                switch (stairType) {
                    case 'straight':
                        console.log("Starting import of CantileverStraightPricing");
                        const cantileverStraightModule = await import('./pricing/CantileverStraightPricing.js');
                        console.log("CantileverStraightPricing loaded in", Date.now() - startTime, "ms");
                        this.pricingModule = new cantileverStraightModule.default(stairInstance);
                        break;
                    case 'L-shaped':
                        console.log("Starting import of CantileverLPricing");
                        const cantileverLModule = await import('./pricing/CantileverLPricing.js');
                        console.log("CantileverLPricing loaded in", Date.now() - startTime, "ms");
                        this.pricingModule = new cantileverLModule.default(stairInstance);
                        break;
                    case 'U-shaped':
                        console.log("Starting import of CantileverUPricing");
                        const cantileverUModule = await import('./pricing/CantileverUPricing.js');
                        console.log("CantileverUPricing loaded in", Date.now() - startTime, "ms");
                        this.pricingModule = new cantileverUModule.default(stairInstance);
                        break;
                    default:
                        console.error('Unknown stair type:', stairType);
                        this.pricingModule = null;
                }
            } else {
            // Load standard versions of the pricing modules
            switch (stairType) {
                case 'straight':
                    const straightModule = await import('./pricing/StraightStairPricing.js');
                    this.pricingModule = new straightModule.default(stairInstance);
                    break;
                case 'L-shaped':
                    const lStairModule = await import('./pricing/LstairPricing.js');
                    this.pricingModule = new lStairModule.default(stairInstance);
                    break;
                case 'U-shaped':
                    const uStairModule = await import('./pricing/UStairPricing.js');
                    this.pricingModule = new uStairModule.default(stairInstance);
                    break;
                case 'Basic-Spiral':
                    const spiralStairModule = await import('./pricing/SpiralStairPricing.js');
                    this.pricingModule = new spiralStairModule.default(stairInstance);
                    break;
                case 'Bespoke-Spiral':
                    const bespokeSpiralStairModule = await import('./pricing/BespokeSpiralStairPricing.js');
                    this.pricingModule = new bespokeSpiralStairModule.default(stairInstance);
                    break;
                default:
                    console.error('Unknown stair type:', stairType);
                    this.pricingModule = null;
            }
        }
    } catch (error) {
        console.error('Error loading pricing module:', error);
        this.pricingModule = null;
        }
    }

    // Function to calculate the total price based on the current pricing module
    calculateTotal(options) {
        if (!this.pricingModule) {
            console.error('No pricing module loaded for the current stair type.');
            return 0;
        }

        return this.pricingModule.calculatePrice(options);
    }
}

export default PricingCalculator;
